<div class="modal-header">
  <h3 class="modal-title">{{"AufbereitungsoptionenGrundstueckAuszug" | translate}}</h3>
  <button (click)="activeModal.close(true)" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  <div class="container-fluid ms-0 ps-0 me-0 pe-0">
    <form [meta]="model" #form="ngForm" column-classes="col-md-2,col-md-10">
      <h2>{{ title }}</h2>

      <br />
      <h3 class="title-divider">{{"Rubriken" | translate}}</h3>
      <cap-form-control labelKey="Grundstückbeschreibung">
        <input
          (ngModelChange)="model && (model.grundstueckBeschreibung = $event)"
          [ngModel]="model && model.grundstueckBeschreibung"
          name="grundstueckPrintOptions.grundstueckBeschreibung"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Eigentum">
        <input
          (ngModelChange)="model && (model.eigentum = $event)"
          [ngModel]="model && model.eigentum"
          name="grundstueckPrintOptions.eigentum"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Dienstbarkeiten">
        <input
          (ngModelChange)="model && (model.dienstbarkeiten = $event)"
          [ngModel]="model && model.dienstbarkeiten"
          name="grundstueckPrintOptions.dienstbarkeiten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Grundlasten">
        <input
          (ngModelChange)="model && (model.grundlasten = $event)"
          [ngModel]="model && model.grundlasten"
          name="grundstueckPrintOptions.grundlasten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Vormerkungen">
        <input
          (ngModelChange)="model && (model.vormerkungen = $event)"
          [ngModel]="model && model.vormerkungen"
          name="grundstueckPrintOptions.vormerkungen"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Anmerkungen">
        <input
          (ngModelChange)="model && (model.anmerkungen = $event)"
          [ngModel]="model && model.anmerkungen"
          name="grundstueckPrintOptions.anmerkungen"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="Grundpfandrechte">
        <input
          (ngModelChange)="model && (model.grundpfandrechte = $event)"
          [ngModel]="model && model.grundpfandrechte"
          name="grundstueckPrintOptions.grundpfandrechte"
          type="checkbox" />
      </cap-form-control>
      @if (isOerebEnabled) {
        <cap-form-control labelKey="Oereb">
          <input
            (ngModelChange)="model && (model.oerebKataster = $event)"
            [ngModel]="model && model.oerebKataster"
            name="grundstueckPrintOptions.oerebKataster"
            type="checkbox" />
        </cap-form-control>
      }
      <br />
      <h3 class="title-divider">{{"Detaillierungsgrad" | translate}}</h3>
      @if (hasToZip) {
        <cap-form-control labelKey="AuszugBearbeiten">
          <input
            (ngModelChange)="model && (model.auszugBearbeiten = $event)"
            [disabled]="model.inEinemDokumentDrucken"
            [ngModel]="model && model.auszugBearbeiten"
            name="AuszugBearbeiten"
            type="checkbox" />
        </cap-form-control>
      }
      @if (hasRequiredErweiterung && hasToZip) {
        <cap-form-control labelKey="InEinemDokumentDrucken">
          <input
            (ngModelChange)="model && (model.inEinemDokumentDrucken = $event)"
            [disabled]="model.auszugBearbeiten"
            [ngModel]="model && model.inEinemDokumentDrucken"
            name="InEinemDokumentDrucken"
            type="checkbox" />
        </cap-form-control>
      }
      <cap-form-control labelKey="EigentumErweitern">
        <input
          (ngModelChange)="model && (model.eigentumErweitern = $event)"
          [ngModel]="model && model.eigentumErweitern"
          name="Eigentum erweitern"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="EigentümerMitAdresseAufbereiten">
        <input
          (ngModelChange)="model && (model.eigentuemerMitAdresse = $event)"
          [ngModel]="model && model.eigentuemerMitAdresse"
          name="EigentuemerMitAdresse"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="UidBeiNatuerlichenPersonenDrucken">
        <input
          (ngModelChange)="model && (model.uidBeiNatuerlichenPersonenDrucken = $event)"
          [ngModel]="model && model.uidBeiNatuerlichenPersonenDrucken"
          name="UidBeiNatuerlichenPersonenDrucken"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="WeitereRechtsgründeAufbereiten">
        <input
          (ngModelChange)="model && (model.weitereRechtsgruendeAufbereiten = $event)"
          [ngModel]="model && model.weitereRechtsgruendeAufbereiten"
          name="Weitere Rechtsgründe aufbereiten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="StandardrechteIdsAufbereiten_DI_GL_SDR_VO_AN">
        <input
          (ngModelChange)="model && (model.standardrechtIdsAufbereiten = $event)"
          [ngModel]="model && model.standardrechtIdsAufbereiten"
          name="StandardrechteIdsAufbereiten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="PfandrechtIdsAufbereiten">
        <input
          (ngModelChange)="model && (model.pfandrechtIdsAufbereiten = $event)"
          [ngModel]="model && model.pfandrechtIdsAufbereiten"
          name="Pfandrecht-IDs aufbereiten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="EreidsAufbereiten">
        <input
          (ngModelChange)="model && (model.ereidsAufbereiten = $event)"
          [ngModel]="model && model.ereidsAufbereiten"
          name="EREIDs aufbereiten"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="VertragstexteAufbereiten">
        <input
          (ngModelChange)="model && (model.vertragstexteAufbereiten = $event)"
          [ngModel]="model && model.vertragstexteAufbereiten"
          name="vertragstexteAufbereiten"
          type="checkbox" />
      </cap-form-control>
      @if (permissionHaengigeGeschaefte) {
        <cap-form-control labelKey="HaengigeGeschaefteAufbereiten">
          <input
            (ngModelChange)="model && (model.haengigeGeschaefteAufbereiten = $event)"
            [ngModel]="model && model.haengigeGeschaefteAufbereiten"
            name="Hängige Geschäfte aufbereiten"
            type="checkbox" />
        </cap-form-control>
      }
      <cap-form-control labelKey="gegeneintraegeDITDienstbarkeitenDrucken">
        <input
          (ngModelChange)="model && (model.gegeneintraegeDITDienstbarkeitenDrucken = $event)"
          [ngModel]="model && model.gegeneintraegeDITDienstbarkeitenDrucken"
          name="GegeneintraegeDITDienstbarkeitenDrucken"
          type="checkbox" />
      </cap-form-control>
      <br />

      <h3 class="title-divider">{{"Einstellungen" | translate}}</h3>

      <button (click)="resetSettings()" class="btn btn-outline-primary" type="button">
        {{ "EinstellungenZuruecksetzen" | translate }}
      </button>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-outline-primary" type="button">{{ "Abbrechen" | translate }}</button>
  <button (click)="confirm()" class="btn btn-primary" type="button">{{ "AuszugErstellen" | translate }}</button>
</div>
